/* import __COLOCATED_TEMPLATE__ from './content-body.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './content-body.module.scss';

@classic
@classNames('location-content-body', 'd-flex', 'text-left', styles.component)
export default class RequestLocationContentBody extends Component {
  @service session;
}
